export const isVue3 = !!import.meta.env.VITE_VUE_3

export const isVue2 = !isVue3

export const DEFAULT_MODEL_EVENT = 'input'

export const DIRECTIVE_HOOKS = {
  BEFORE_MOUNT: 'bind',
  UNMOUNTED: 'unbind',
  UPDATED: 'componentUpdated',
}

export const COMPONENT_HOOKS = {
  BEFORE_UNMOUNT: 'beforeDestroy',
}
